import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[addressDetailDirective]',
})
export class AddressDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}